export { SlotChangeSeatsStep, type SlotChangeSeatsStepProps } from "./SlotChangeSeatsStep"
